import "./responsive-container.less"
import { boolOr, classNames } from "utils/helpers"
import { CSSProperties, PropsWithChildren } from "react"

interface Props {
  className?: string
  centerContents: boolean
  visible?: boolean
  style?: CSSProperties
}

export default function ResponsiveContainer(props: PropsWithChildren<Props>) {
  const { className, centerContents } = props

  const visible = boolOr(props.visible, true)

  if (visible) {
    return (
      <div
        className={classNames("responsive-container", className, {
          center: centerContents,
        })}
        style={props.style}
      >
        {props.children}
      </div>
    )
  } else {
    return null
  }
}
